const input = {
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    email: 'E-mail',
    phone_number: 'Numer telefonu',
    confirm_password: 'Potwierdź hasło',
    search_region_code: 'Kod regionu wyszukiwania',
    backup_code: 'Kod kopii zapasowej',
    code: 'Kod',
    label_with_optional: '{{label}} (Opcjonalne)',
    email_address: 'Adres e-mail',
    email_placeholder: 'Wpisz swój e-mail',
    enter_email: 'Wpisz e-mail',
};
export default Object.freeze(input);
